module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Upload_Black.15738902.svg";